import { useEffect, useState } from "react";
import { getPropValue } from '../crud/utils';
import { Typography } from "@mui/material";
import { format } from 'date-fns';
import { getCultureInfo, getisoWeekDays, getIsoWeekStartOf } from '../crud/utils';
import { t } from "./../i18n";
import './Calendar.css';
import { Round } from '../crud/utils';

function WeekView(props) {
    const [language] = useState(getCultureInfo(props.userApp.sessionToken?.Language));
    const [User3pl] = useState(props.userApp.sessionToken?.User3pl);
    const [SupplierId] = useState(props.userApp.sessionToken?.SupplierId);
    const [role] = useState(props.userApp.sessionToken?.Role);
    const [ymsBooking, setYmsBooking] = useState([]);
    const [days, setDays] = useState([]);
    const weekDays = getisoWeekDays(language);
    const app = props.userApp;
    const getWeekDays = (startOfWeek) => {
        const dates = Array.from({ length: 7 }, (_, i) => {
            const d = new Date(startOfWeek);
            d.setDate(d.getDate() + i);
            d.setHours(0, 0, 0, 0);
            return d;
        });
        return dates;
    };

    const today = new Date();

    useEffect(() => {
        async function getBooking() {
            let data = (props.data["Yms_Booking"]) ? props.data["Yms_Booking"] : [];
            setYmsBooking(data);
            const startOfWeek = getIsoWeekStartOf(props.currentDate);
            setDays(getWeekDays(startOfWeek));
        }
        getBooking();
    }, [props.data, props.currentDate]);

    if (!props.warehouseid) return;

    function getColValue(row, columnName) {
        return getPropValue(row, columnName);
    }

    // function getDropDownValue(row, columnName) {
    //     let col = props.allColumnsObj["Yms_Booking"].columns.find(e => e.columnName === "Status");
    //     if (col && col.controlOptions) {
    //         let selectitem = col.controlOptions.find(item => item.value === getPropValue(row, columnName));
    //         return selectitem.text;
    //     }
    //     return "";
    // }

    function gatDisabledView(recYmsbook) {
        if (role === "Supplier" || role === "3pls") {
            if (SupplierId) {
                const BookingSuppliersID = recYmsbook?.BookingSuppliersID?.split(",").map(Number);
                const exists = BookingSuppliersID?.includes(Number(SupplierId));
                if (!exists) return true;
            }
            else if (User3pl) {
                if (!props.data["Yms_3plSuppliers"]) return true;
                const Booking3plSuppliersID = recYmsbook?.Booking3plSuppliersID?.split(",").map(Number);
                const exists = props.data["Yms_3plSuppliers"].some(supplier => Booking3plSuppliersID?.includes(Number(supplier.SupplierId)));
                if (!exists) return true;
            }
        }
        return false;
    }

    return (
        <div style={{ height: "100%" }}>
            <div className="calendar-header-container">
                {weekDays.map((day, index) => (
                    <div key={index} className="calendar-header">
                        <span>{day}</span>
                    </div>
                ))}
            </div>
            <div className="calendar-grid calendar-grid-week">
                <div className="calendar-grid-7-columns" style={{ display: 'grid' }}>
                    {days.map((day, index) => {
                        const isToday = format(day, "dd/MM/yyyy") === format(today, "dd/MM/yyyy");
                        const dayEvents = ymsBooking
                            .filter(event => format(day, "dd/MM/yyyy") === format(event.FromDate, "dd/MM/yyyy"))
                            .sort((a, b) => a.FromDate - b.FromDate);

                        return (
                            <div
                                key={index}
                                className={`calendar-day-week ${isToday ? 'today' : ''}`}
                                onClick={() => {
                                    props.setCurrentDate(day);
                                    props.setView("day");
                                }}
                            >

                                <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '8px', color: 'var(--color-main-background)' }}>
                                    {format(day, "d")}
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minHeight: '100px' }}>
                                    {dayEvents.length === 0 ? (
                                        <Typography sx={{
                                            color: "#999",
                                            fontSize: "11px",
                                            fontStyle: "italic",
                                            mt: "auto",
                                            mb: "auto"
                                        }}>
                                            {t("calendarEvent.noEvents", language) || "No events"}
                                        </Typography>
                                    ) : (
                                        dayEvents.map((event, eventIndex) => {
                                            const { dotColor, statusName, bgColor } = props.getEventColors(event.Status);
                                            const isDisabled = gatDisabledView(event);

                                            return (
                                                <div
                                                    key={eventIndex}
                                                    className="calendar-event"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!isDisabled) {
                                                            props.setSelectedEvent(event.BookingId);
                                                            props.setCurrentDate(new Date(event.FromDate));
                                                            props.setView("day");

                                                            setTimeout(() => {
                                                                const eventElement = document.getElementById(`event-${event.BookingId}`);
                                                                if (eventElement) {
                                                                    eventElement.scrollIntoView({ behavior: "smooth", block: "center" });
                                                                }
                                                            }, 300);
                                                        }
                                                    }}
                                                    style={{
                                                        opacity: isDisabled ? 0.5 : 1,
                                                        pointerEvents: isDisabled ? "none" : "auto",
                                                        borderLeft: `3px solid ${bgColor}`,
                                                        backgroundColor: app.theme === 'dark' ? dotColor : bgColor,
                                                    }}
                                                    id={`event-${event.BookingId}`}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
                                                        <span style={{
                                                            display: "inline-block",
                                                            width: "8px",
                                                            height: "8px",
                                                            borderRadius: "50%",
                                                            backgroundColor: app.theme === 'light' ? dotColor : bgColor,
                                                        }} />
                                                        <span style={{ fontSize: '11px', fontWeight: 600, color: '#333' }}>
                                                            {format(event.FromDate, "HH:mm")}
                                                        </span>
                                                    </div>
                                                    {!isDisabled && (
                                                        <div className="d-flex flex-column justify-content-center align-items-start">
                                                            <div style={{ marginBottom: '5px' }}><span style={{ fontWeight: '700', fontSize: '12px' }}> {getColValue(event, "SupNameShort") || getColValue(event, "SupDescr") || t("calendarEvent.withOutSupplier", language)}</span></div>

                                                            {getColValue(event, "ArrivalId") && (
                                                                <Typography variant="body3" fontWeight="bold">
                                                                    <i className="bi bi-box-arrow-in-right" style={{ marginRight: "5px" }}></i>
                                                                    Arrival ID: {getColValue(event, "ArrivalId")}
                                                                </Typography>
                                                            )}
                                                            {getColValue(event, "CapacityMinutes") && (() => {
                                                                let decimals = Number("0" || 0);
                                                                return (
                                                                    <Typography variant="body3" fontWeight="bold" className="mb-2">
                                                                        <i className="bi bi-hourglass-split" style={{ marginRight: "5px" }}></i>
                                                                        {t("calendarEvent.duration", language)}: {Round(getColValue(event, "CapacityMinutes"), decimals)} {t("ModalBooking.minutesCapitalized", language)}
                                                                    </Typography>
                                                                );
                                                            })()}
                                                            {getColValue(event, "rampNumber") && <Typography variant="body4" color="textSecondary">
                                                                <i className="bi bi-geo-alt" style={{ marginRight: "5px" }}></i>
                                                                {t("calendarEvent.ramp", language)}: {getColValue(event, "rampNumber")}
                                                            </Typography>}
                                                            <Typography variant="body4" color="textSecondary">
                                                                <i className="bi bi-car-front" style={{ marginRight: "5px" }}></i>
                                                                {t("calendarEvent.plate", language)}:{getPropValue(event, "YmsTrk1.LicenseNo")}
                                                            </Typography>

                                                            {getColValue(event, "DriverId") && (
                                                                <Typography variant="body4" color="textSecondary">
                                                                    <i className="bi bi-person-lines-fill" style={{ marginRight: "5px" }}></i>
                                                                    {t("calendarEvent.driver", language)}: {getPropValue(event, "YmsDri1.Name1")}
                                                                </Typography>
                                                            )}
                                                            {getColValue(event, "Phone") && (
                                                                <Typography variant="body4">
                                                                    <i className="bi bi-telephone" style={{ marginRight: "5px" }}></i>
                                                                    {t("calendarEvent.phone", language)}: {getColValue(event, "Phone")}
                                                                </Typography>
                                                            )}
                                                            <Typography variant="body4" color="textSecondary">
                                                                <i className="bi bi-file-earmark-text" style={{ marginRight: "5px" }}></i>
                                                                {getColValue(event, "BookingId")}
                                                            </Typography>
                                                            <div style={{
                                                                width: '100%',
                                                                marginTop: '4px',
                                                                paddingTop: '4px',
                                                                borderTop: '1px solid rgba(0,0,0,0.1)',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            }}>
                                                                <span style={{ fontSize: '9px', color: '#666' }}>
                                                                    {getColValue(event, "CapacityMinutes")} {t("ModalBooking.minutes", language)}
                                                                </span>
                                                                <span style={{
                                                                    fontSize: '9px',
                                                                    fontWeight: 600,
                                                                    color: dotColor,
                                                                    textTransform: 'capitalize'
                                                                }}>
                                                                    {statusName}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default WeekView;